<template>
  <router-link
    class="mt-1 group flex items-center px-3 py-3 text-s leading-5 font-medium text-gray-200 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
    :active-class="!disableActiveClass ? 'bg-gray-900 hover:bg-gray-900' : ''"
    :to="route"
  >
    <div class="mr-4 w-4 text-center" v-if="icon">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </div>

    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    icon: String,
    to: {
      type: String | Object,
    },
    disableActiveClass: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    route() {
      if (this.to == undefined) {
        return { name: "" };
      } else if (this.to != null && typeof this.to === "object") {
        return this.to;
      } else {
        return { name: this.to };
      }
    },
  },
};
</script>
